const config = {
  env: "local",
  apiUrl: "https://api.bsconnect.store/api/",
  // apiUrl: "http://192.168.0.129:5003/api/"
}

export default config;
